import { Box, Typography, useTheme } from '@mui/material';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';
import { isWeekend } from './isWeekend';

export const GantDay = forwardRef(
  ({ day, format = 'DD', isFirst, isLast, dayRef }, ref) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
    const { t } = useTranslation();

    const { date, hasWPStart, hasWPEnd } = day;

    const bgcolor = isWeekend(date) ? colors.warning + '60' : 'transparent';
    const isToday = date.isSame(moment(), 'day');

    return (
      <Box
        ref={dayRef}
        sx={{
          bgcolor,
        }}
        className="h-full w-full flex flex-col"
      >
        <Box
          sx={{
            bgcolor: isToday ? colors.info + '80' : colors.glass,
            //border: isToday ? `4px solid ${colors.selected}` : '',
            //borderBottom: '0px',
          }}
          className="p-2 flex flex-col items-center z-10"
        >
          <Typography
            textAlign="center"
            fontWeight={600}
            className={` opacity-70 aspect-square rounded-md flex items-center justify-center w-[25px] h-[25px]`}
            sx={{
              bgcolor:
                //isToday ? colors.info + '80' :
                'transparent',
            }}
          >
            {date.format(format)}
          </Typography>
          <Typography
            textAlign="center"
            fontSize={10}
            fontWeight={500}
            className=" opacity-50"
          >
            {t(date.format('dddd'))}
          </Typography>
        </Box>
        <Box
          className="w-full h-full"
          sx={{
            bgcolor: isToday ? colors.info + '80' : colors.glass,
            borderWidth:
              //isToday ? `0px 4px 0px ${isFirst ? 0 : 4}px`:
              `2px 0px 0px ${isFirst ? 0 : 1}px`,
            borderStyle: 'solid',
            borderColor:
              //isToday ? colors.selected :
              colors.bgInput,
          }}
        ></Box>
      </Box>
    );
  }
);
